package com.mgacreative.hotel.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class SupplierCategory(
    val id: String? = null,
    val tenant_id: String? = null,
    val name: String,
    val created_at: String? = null
)

@Serializable
data class Supplier(
    val id: String? = null,
    val tenant_id: String? = null,
    val category_id: String? = null,
    val name: String,
    val contact_info: String? = null,
    val created_at: String? = null
)
